import { Modal } from 'antd';
import styled from 'styled-components';

import colors from '../../../../../styles/colors';

export const CustomModal = styled(Modal)`
  width: 800px !important;
  height: 558px !important;
  display: flex;
  flex-direction: column;

  .ant-modal-body {
    margin: 8px 4px;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: flex-end;
    border: none;
    margin-right: 20px;
    margin-bottom: 20px;
  }
`;

export const ModalTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 130%;

  display: flex;
  flex-direction: row;
  align-items: center;

  color: ${colors.$brandcolor_primary_blue};
  margin-bottom: 32px;
`;

export const GridDadosItem = styled.div`
  gap: 8px;
  margin-bottom: 20px;
`;
export const GridDadosItemText = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: ${props => (props.regular ? 400 : 600)};
  font-size: 16px;
  line-height: 150%;
  color: ${props =>
    props.regular ? colors.$greyscale_dark_grey_10 : colors.$greyscale_black_5};
  margin-bottom: 8px;
`;

export const GridTitle = styled.div`
  font-family: 'Inter';
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 20px;
  margin-top: 20px;

  p {
    font-family: 'Inter';
    color: ${colors.dark_blue};
    font-weight: 700;
    line-height: 22px;
  }
`;

export const Container = styled.div`
  width: 760px !important;
  height: 458px !important;

  overflow: scroll;
`;
